<template>
  <div>
  <the-headersider></the-headersider>

    <!-- Search & Actions -->
    <base-card class="toolbar">
      <input
        type="search"
        class="form-control"
        v-model="search"
        placeholder="Search by name, phone, estate, apartment or house no"
      />

     
<div class="row">
  <div class="col">
     <button class="btn btn-success" @click="downloadPDF">
          ⬇ Download Clients (PDF)
        </button>

  </div>
  <div class="col">
     <button class="btn btn-success" @click="downloadCSV">
          ⬇ Download Clients (CSV)
        </button>

  </div>
   <div class="toolbar-actions col">
        <router-link to="/register/clients" class="link btn btn-secondary">
          + Register Client
        </router-link>
  
</div>
       
      </div>
    </base-card>

    <!-- Clients Table -->
    <base-card>
      <div class="table-wrapper">
        <table class="table table-striped table-bordered fancy-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Phone</th>
              <th>Account</th>
              <th>Estate</th>
              <th>Apartment</th>
              <th>House No</th>
              <th>Monthly</th>
              <th>Arrears</th>
              <th>Status</th>
               <th>Type</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="filteredClients.length === 0">
              <td colspan="10" class="empty">
                No clients found
              </td>
            </tr>

            <tr
              v-for="client in filteredClients"
              :key="client.id"
            >
              <td class="name">
                <router-link
                  :to="`/client/payments/${client.client_id}`"
                >
                  {{ client.name }}
                </router-link>
              </td>

              <td>{{ client.phone }}</td>
              <td>{{ client.client_id }}</td>
              <td>{{ client.estate }}</td>
              <td>{{ client.apartment }}</td>
              <td>{{ client.house_number }}</td>
              <td>KES {{ client.montlyPayment }}</td>
              <td class="arrears">
                KES {{ client.arrears }}
              </td>

              <td>
                <span
                  class="status"
                  :class="client.isActive ? 'active' : 'inactive'"
                >
                  {{ client.isActive ? "Active" : "Inactive" }}
                </span>
              </td>
              <td>{{ client.client_type }}</td>

              <td>
                <router-link
                  :to="`/edit/client/${client.client_id}`"
                  class="edit"
                >
                  Edit
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </base-card>
  </div>
</template>

<script>
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  data() {
    return {
      search: "",
    };
  },

  computed: {
    clients() {
      return this.$store.getters.clients;
    },

    filteredClients() {
      const key = this.search.toLowerCase();

      return this.clients.filter(client =>
        client.name.toLowerCase().includes(key) ||
        client.phone.toString().includes(key) ||
        client.client_id.toString().includes(key) ||
        (client.estate || "").toLowerCase().includes(key) ||
        (client.apartment || "").toLowerCase().includes(key) ||
        (client.houseNumber || "").toLowerCase().includes(key) ||
        (client.client_type || "").toLowerCase().includes(key)
      );
    },
  },

  created() {
    this.$store.dispatch("LoadClients");
  },

  methods: {
    downloadPDF() {
      const pdf = new jsPDF();

      const columns = [
        "Account",
        "Name",
        "Phone",
        "Estate",
        "Apartment",
        "House No",
        "Arrears",
        "Type"
      ];

      const rows = this.clients.map(c => [
                 c.client_id,

        c.name,
        c.phone,
        c.estate,
        c.apartment,
        c.house_number,
        c.arrears,
        c.client_type,

      
      ]);

      pdf.text("Green Belt Life Afrika – Clients", 55, 20);
      pdf.line(0, 25, 210, 25);

      pdf.autoTable(columns, rows, {
        startY: 30,
        styles: { fontSize: 9 },
        headStyles: { fillColor: [40, 116, 240] },
      });

      pdf.save("All_Clients.pdf");
    },
    downloadCSV() {
  // Build timestamp: 2026-01-16_14-32
  const now = new Date();
  const timestamp = now.toISOString()
    .replace(/T/, "_")
    .replace(/:/g, "-")
    .split(".")[0];

  const headers = [
    "Account",
    "Name",
    "Phone",
    "Estate",
    "Apartment",
    "House No",
    "Arrears",
    "Type"
  ];

  // Filter only active clients
  const activeClients = this.clients.filter(c => 
    c.isActive === 1 || 
    c.isActive === true || 
    c.isActive === "1" || 
    c.isActive === "true"
  );

  const rows = activeClients.map(c => [
    c.client_id,
    c.name,
    c.phone,
    c.estate,
    c.apartment,
    c.house_number,
    c.arrears,
    c.client_type
  ]);

  const csvContent = [headers, ...rows]
    .map(row =>
      row
        .map(value =>
          `"${String(value !== null && value !== undefined ? value : "")
            .replace(/"/g, '""')}"`
        )
        .join(",")
    )
    .join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute(
    "download",
    `Active_Clients_${timestamp}.csv`
  );

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(url);
},
//     downloadCSV() {
//   // Build timestamp: 2026-01-16_14-32
//   const now = new Date();
//   const timestamp = now.toISOString()
//     .replace(/T/, "_")
//     .replace(/:/g, "-")
//     .split(".")[0];

//   const headers = [
//     "Account",
//     "Name",
//     "Phone",
//     "Estate",
//     "Apartment",
//     "House No",
//     "Arrears",
//     "Type"
//   ];

//   const rows = this.clients.map(c => [
//     c.client_id,
//      c.name,
//     c.phone,
//     c.estate,
//     c.apartment,
//     c.house_number,
//     c.arrears,
//     c.client_type
//   ]);

// const csvContent = [headers, ...rows]
//   .map(row =>
//     row
//       .map(value =>
//         `"${String(value !== null && value !== undefined ? value : "")
//           .replace(/"/g, '""')}"`
//       )
//       .join(",")
//   )
//   .join("\n");

//   const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//   const url = URL.createObjectURL(blob);

//   const link = document.createElement("a");
//   link.href = url;
//   link.setAttribute(
//     "download",
//     `All_Clients_${timestamp}.csv`
//   );

//   document.body.appendChild(link);
//   link.click();

//   document.body.removeChild(link);
//   URL.revokeObjectURL(url);
// },


  },
};
</script>

<style scoped>
.toolbar {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
}

.toolbar-actions {
  display: flex;
  gap: 1rem;
}

.form-control {
  width: 50%;
  padding: 0.6rem;
  border-radius: 8px;
  border: 1px solid #ccc;
}

.table-wrapper {
  overflow-x: auto;
}

.fancy-table thead th {
  position: sticky;
  top: 0;
  background: #f8fafc;
  z-index: 2;
}

.name a {
  font-weight: 600;
  color: #2563eb;
}

.name a:hover {
  text-decoration: underline;
}

.arrears {
  color: #dc2626;
  font-weight: 600;
}

.status {
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
}

.status.active {
  background: #dcfce7;
  color: #166534;
}

.status.inactive {
  background: #fee2e2;
  color: #991b1b;
}

.edit {
  color: #2563eb;
  font-weight: 600;
}

.empty {
  text-align: center;
  padding: 1rem;
}
</style>
